import Navbar from '../components/layout/Navbar';
import Hero from '../features/home/Hero';
import Features from '../features/home/Features';
import TimelineSection from '../features/home/TimelineSection';
import FounderSection from '../features/home/FounderSection';
import ExclusivitySection from '../features/home/ExclusivitySection';
import Calculator from '../features/pricing/Calculator';
import Footer from '../components/layout/Footer';

export default function Home() {
  return (
    <div className="min-h-screen flex flex-col font-sans text-black-deep bg-cream-100">
      <Navbar />
      <main className="flex-grow">
        <Hero />
        <TimelineSection />
        <FounderSection />
        <ExclusivitySection />
        <Features />
        <Calculator />
      </main>
      <Footer />
    </div>
  );
}
